import { Flex, Divider, Box, Button, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { PriorCadEventsTable } from './prior-cad-events-table';
import { GeoPointLocation } from '../../../esri/types';
import { useLocationRelatedData } from '../../hooks/use-location-related-data';
import { EmptyPropsWithChildren } from '@m43/core';

type LocationRelatedDataSectionProps = {
    geoPointLocation?: GeoPointLocation;
};

function MessageText({ children }: EmptyPropsWithChildren) {
    return <Text data-testid="MAP_LOCATION_NO_PRIOR_CAD_EVENTS_MESSAGE">{children}</Text>;
}

export const LocationRelatedDataSection = observer(function LocationRelatedDataSection({
    geoPointLocation,
}: LocationRelatedDataSectionProps): React.ReactElement {
    const { isLoading, data: relatedData, isError, refetch } = useLocationRelatedData(
        geoPointLocation
    );
    return (
        <Box>
            <Flex
                direction="column"
                padding="12px 18px"
                data-testid="MAP_LOCATION_PIN_RELATED_DATA_SECTION"
            >
                <Box marginBottom={3}>
                    <Text variant="headingXs">Recent CAD Events</Text>
                </Box>
                {isLoading ? (
                    <MessageText>Loading recent CAD events...</MessageText>
                ) : isError ? (
                    <MessageText>
                        Error loading recent CAD events.
                        <Button
                            size="sm"
                            onClick={() => {
                                refetch();
                            }}
                        >
                            Try again
                        </Button>
                    </MessageText>
                ) : relatedData?.cadEvents?.length === 0 ? (
                    <MessageText>No CAD Events Found</MessageText>
                ) : (
                    <PriorCadEventsTable cadEvents={relatedData?.cadEvents} />
                )}
            </Flex>
            <Divider />
        </Box>
    );
});
